var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image"},[_vm._t("headerImage",function(){return [_vm._v(" Image ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }